import React, { useState } from "react";
import "./style.css";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import {
  auth,
  getUserDetails,
  sendResetPasswordLink,
} from "../../utils/firebase-config";
import { useNavigate } from "react-router-dom";

function ResetPasswordScreen() {
  let navigate = useNavigate();

  const [formData, setFormData] = useState({ email: "" });
  // const [isRegistering, setIsRegistering] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);

    sendResetPasswordLink(formData.email).then(() => {
      window.alert(
        "Reset Password link has been sent to your email : " + formData.email
      );
      navigate("/");
    });
  };

  return (
    <div style={{ display: "inline-grid", width: "98%" }}>
      <form onSubmit={handleSubmit}>
        <div className="form-login" style={{ gridTemplateColumns: "1fr" }}>
          <div className="input-field">
            <label>Email</label>
            <input
              className="form-input"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <button className="submit-btn" type="submit">
          {"Send Reset Link"}
        </button>
      </form>
    </div>
  );
}

export default ResetPasswordScreen;
